// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"az_sr","skinnyRecommendations":"az_tr"};